import getDistance from './getDistance';
import getPadding from './getPadding';

const EPS = 0.01;

function fitOnMap(map, bounds, { zoom }) {
  if (bounds && bounds.length > 1 && getDistance(bounds) > EPS) {
    map.fitBounds(bounds, getPadding());
  } else {
    map.setView(bounds[0], zoom);
  }
}

export default fitOnMap;
